import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { resourceExplorerWidgetDataSelector } from "./resource-explorer-widget/resourceExplorerWidgetDataSelector";
import { aggregateResourceExplorerChartDataSeriesTotalCostsMap } from "../../utils/helpers/chart/aggregateResourceExplorerChartDataSeriesTotalCostsMap";

export const resourceExplorerChartDataSeriesTotalCostsMapSelector =
  createDraftSafeSelector([resourceExplorerWidgetDataSelector], (chartData) => {
    if (!chartData?.data) {
      return;
    }

    return aggregateResourceExplorerChartDataSeriesTotalCostsMap(
      chartData.data,
    );
  });
